import React, { createContext, useContext } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const ToastContext = createContext<{
  error: (params: { message: string }) => void
  success: (params: { message: string }) => void
}>({} as any)

const ToastContextProvider = ({ children }: { children: React.ReactNode }) => {
  const error = ({ message }: { message: string }) => {
    toast.error(message)
  }
  const success = ({ message }: { message: string }) => {
    toast.success(message)
  }

  return (
    <ToastContext.Provider
      value={{
        error,
        success
      }}
    >
      <ToastContainer />
      {children}
    </ToastContext.Provider>
  )
}
export default ToastContextProvider
export const useToastContext = () => useContext(ToastContext)
